(() => {
  if (window.PuzzlePupReviewFallback) return;

  const nativeReviewSelector = '.jdgm-rev-widg, .jdgm-rev, .jdgm-row-stars, [data-testid="review-widget"]';

  function create(tag, className, text) {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  }

  function render(widget) {
    if (!widget || widget.querySelector(nativeReviewSelector) || widget.querySelector('[data-pp-review-fallback]')) return;
    const productId = widget.dataset.productId || widget.dataset.id;
    const data = window.jdgm?.data?.reviewWidget?.[productId];
    const reviews = Array.isArray(data?.reviews) ? data.reviews : [];
    if (!reviews.length) return;

    const fallback = create('div', 'pp-v3-review-fallback');
    fallback.dataset.ppReviewFallback = 'true';
    const summary = create('div', 'pp-v3-review-fallback__summary');
    const stars = create('span', 'pp-stars', '★★★★★');
    stars.setAttribute('aria-hidden', 'true');
    const average = Number(data.average_rating || 0);
    const label = create('strong', '', average.toFixed(1) + ' out of 5');
    label.setAttribute('aria-label', average.toFixed(1) + ' out of 5 stars');
    summary.append(stars, label);

    const grid = create('div', 'pp-v3-review-fallback__grid');
    reviews.slice(0, 5).forEach(review => {
      const card = create('article', 'pp-v3-review-card');
      const rating = Math.max(0, Math.min(5, Math.round(Number(review.rating) || 0)));
      const cardStars = create('span', 'pp-stars', '★'.repeat(rating) + '☆'.repeat(5 - rating));
      cardStars.setAttribute('aria-label', String(rating) + ' out of 5 stars');
      const quote = create('blockquote', '', review.body || review.body_html?.replace(/<[^>]*>/g, '') || '');
      const author = create('footer', '', review.reviewer_name || 'PuzzlePup customer');
      card.append(cardStars, quote, author);
      grid.append(card);
    });
    fallback.append(summary, grid);
    widget.append(fallback);

    const observer = new MutationObserver(() => {
      if (!widget.querySelector(nativeReviewSelector)) return;
      fallback.remove();
      observer.disconnect();
    });
    observer.observe(widget, { childList: true, subtree: true });
  }

  function init(scope = document) {
    if (scope.querySelector('[data-pp-review-server]')) return;
    scope.querySelectorAll('#judgeme_product_reviews').forEach(widget => {
      window.setTimeout(() => render(widget), 900);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  else init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  window.PuzzlePupReviewFallback = Object.freeze({ init, render });
})();
